module.exports = __webpack_public_path__ + "officialStatic/img/wx-public.6c0c5da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/wx-public.jpg
// module id = rfQc
// module chunks = 0